export default __webpack_public_path__ + "static/media/SketchUp-OkCVaMpMm_brandlogos.net.f036d6a8.svg";